import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/material';

import Accordion from '~/components/ui/Accordion/Accordion';
import { Button } from '~/components/ui/button';
import VCardPlusContactInfoEmailItem from '~/components/VCardPlusQRContent/VCardPlusBasicInformation/VCardPlusContactInfoEmailItem';
import VCardPlusContactInfoPhoneItem from '~/components/VCardPlusQRContent/VCardPlusBasicInformation/VCardPlusContactInfoPhoneItem';
import VCarPlusContactInfoWebsiteItem from '~/components/VCardPlusQRContent/VCardPlusBasicInformation/VCarPlusContactInfoWebsiteItem';
import { VCardPlusData } from '~/types/qrCode';

type VCardContactInfoProps = {
  createVCardPlusEmail?: () => void;
  createVCardPlusPhone?: () => void;
  createVCardPlusWebsite?: () => void;
  vCardPlusData: VCardPlusData;
  updateVCardPlusEmail?: () => void;
  updateVCardPlusPhone?: () => void;
  updateVCardPlusWebsite?: () => void;
  deleteVCardPlusEmail?: () => void;
  deleteVCardPlusPhone?: () => void;
  deleteVCardPlusWebsite?: () => void;
  isPendingDeleteVCardPlusPhone?: boolean;
  isPendingDeleteVCardPlusEmail?: boolean;
  isPendingDeleteVCardPlusWebsite?: boolean;
};
export default function VCardContactInfo({
  createVCardPlusEmail,
  createVCardPlusPhone,
  createVCardPlusWebsite,
  vCardPlusData,
  deleteVCardPlusWebsite,
  deleteVCardPlusEmail,
  deleteVCardPlusPhone,
  updateVCardPlusEmail,
  updateVCardPlusPhone,
  updateVCardPlusWebsite,
  isPendingDeleteVCardPlusPhone,
  isPendingDeleteVCardPlusEmail,
  isPendingDeleteVCardPlusWebsite,
}: VCardContactInfoProps) {
  const { t } = useTranslation();

  const onAddEmail = () => {
    if (vCardPlusData?.id) {
      createVCardPlusEmail({
        title: '',
        email: '',
        microsite: vCardPlusData.id,
      });
    }
  };

  const onAddWebsite = () => {
    if (vCardPlusData?.id) {
      createVCardPlusWebsite({
        title: '',
        url: '',
        microsite: vCardPlusData.id,
      });
    }
  };

  const onAddPhone = () => {
    if (vCardPlusData?.id) {
      createVCardPlusPhone({
        type: 'WORK',
        title: '',
        phone: '',
        microsite: vCardPlusData?.id,
      });
    }
  };

  return (
    <Accordion
      defaultExpanded
      variant="child"
      summary={t('template5:constactInfo')}
      details={
        <>
          <Box sx={{ marginBottom: '12px' }}>
            {vCardPlusData?.phones?.map((itemPhone) => {
              return (
                <VCardPlusContactInfoPhoneItem
                  key={itemPhone.id}
                  deleteVCardPlusPhone={deleteVCardPlusPhone}
                  isPendingDeleteVCardPlusPhone={isPendingDeleteVCardPlusPhone}
                  phone={itemPhone}
                  updateVCardPlusPhone={updateVCardPlusPhone}
                />
              );
            })}
            <Button
              type="primary-outlined"
              startIcon={<AddIcon />}
              onClick={onAddPhone}
              size="xs"
              sx={{ marginTop: vCardPlusData?.phones?.length ? '16px' : undefined }}
            >
              {t('template5:addPhone')}
            </Button>
          </Box>
          <Box sx={{ marginBottom: '12px' }}>
            {vCardPlusData?.emails?.map((itemEmail) => {
              return (
                <VCardPlusContactInfoEmailItem
                  key={itemEmail.id}
                  email={itemEmail}
                  deleteVCardPlusEmail={deleteVCardPlusEmail}
                  isPendingDeleteVCardPlusEmail={isPendingDeleteVCardPlusEmail}
                  updateVCardPlusEmail={updateVCardPlusEmail}
                />
              );
            })}
            <Button
              type="primary-outlined"
              startIcon={<AddIcon />}
              onClick={onAddEmail}
              size="xs"
              sx={{ marginTop: vCardPlusData?.emails?.length ? '16px' : undefined }}
            >
              {t('template5:addEmail')}
            </Button>
          </Box>
          {vCardPlusData?.websites?.map((itemWebsite) => {
            return (
              <VCarPlusContactInfoWebsiteItem
                key={itemWebsite.id}
                deleteVCardPlusWebsite={deleteVCardPlusWebsite}
                updateVCardPlusWebsite={updateVCardPlusWebsite}
                isPendingDeleteVCardPlusWebsite={isPendingDeleteVCardPlusWebsite}
                website={itemWebsite}
              />
            );
          })}
          <Button
            type="primary-outlined"
            startIcon={<AddIcon />}
            onClick={onAddWebsite}
            size="xs"
            sx={{ marginTop: vCardPlusData?.websites?.length ? '16px' : undefined }}
          >
            {t('template5:addWeb')}
          </Button>
        </>
      }
    />
  );
}
